import config from 'config/envConfig';
import { postReq } from '../axios/makeRequest';

export const trackGeoLocation = () => postReq(`${config.oneLifeApiUrl}/config/Geolocation/createGeolocationLog`);
